


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import {
  fetchLeaveStatus,
  fetchRemainingLeaves,
} from '../../redux/actions/leaveActions';

const LeaveDetails = () => {
  const dispatch = useDispatch();

  const { remainingLeaves, leaveStatusData, leaveTypes } = useSelector((state) => state.leave);

  useEffect(() => {
    dispatch(fetchRemainingLeaves());
    dispatch(fetchLeaveStatus());
  }, [dispatch]);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved':
        return 'bg-green-100 text-green-700';
      case 'rejected':
        return 'bg-red-200 text-red-800';
      case 'pending':
      default:
        return 'bg-yellow-100 text-yellow-800';
    }
  };

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });

  return (
    <div className="bg-[#2C3E50] min-h-screen text-white p-4 pt-6">
      {/* Leave Summary */}
      {/* <div>
        <h2 className="text-xl font-semibold mb-2">Leave Summary</h2>
        <div className="w-6 h-1 bg-blue-500 rounded-full mb-4"></div>

        <div className="grid grid-cols-2 gap-4">
          {remainingLeaves?.data?.map((leave) => (
            <div
              key={leave.leave_type_id}
              className="bg-white rounded-2xl p-4 shadow-md text-black flex flex-col justify-between"
            >
              <div className="flex justify-between items-center mb-2">
                <span className="font-semibold">{leave.leave_type_name}</span>
                <span className="text-sm bg-[#E6F0FA] text-blue-600 font-bold px-2 py-1 rounded-full">
                  {leave.total_leaves}/{leave.total_leaves}
                </span>
              </div>
              <div className="border-t border-gray-300 my-2"></div>
              <div className="text-sm text-right text-gray-500 mb-2">
                {leave.used_leaves} used
              </div>
              <div className="grid grid-cols-3 text-center text-sm font-semibold">
                <div>
                  <p className="text-lg">{leave.total_leaves}</p>
                  <p className="text-gray-500 text-xs">Total</p>
                </div>
                <div>
                  <p className="text-lg">{leave.used_leaves}</p>
                  <p className="text-gray-500 text-xs">Used</p>
                </div>
                <div>
                  <p className="text-lg text-green-600">
                    {leave.remaining_leaves}
                  </p>
                  <p className="text-gray-500 text-xs">Remaining</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}
      {/* Leave Summary */}
<div>
  <h2 className="text-xl font-semibold mb-2">Leave Summary</h2>
  <div className="w-6 h-1 bg-blue-500 rounded-full mb-4"></div>

  <div className="flex space-x-4 overflow-x-auto pb-2">
    {leaveTypes?.data?.leaves?.map((leave) => (
      <div
        key={leave.leave_type_id}
        className="min-w-[250px] bg-white rounded-2xl p-4 shadow-md text-black flex-shrink-0"
      >
        <div className="flex justify-between items-center mb-2">
          <span className="font-semibold">{leave.leave_type_name}</span>
          <span className="text-sm bg-[#E6F0FA] text-blue-600 font-bold px-2 py-1 rounded-full">
            {leave.total_leaves}/{leave.total_leaves}
          </span>
        </div>
        <div className="border-t border-gray-300 my-2"></div>
        <div className="text-sm text-right text-gray-500 mb-2">
          {leave.used_leaves} used
        </div>
        <div className="grid grid-cols-3 text-center text-sm font-semibold">
          <div>
            <p className="text-lg">{leave.total_leaves}</p>
            <p className="text-gray-500 text-xs">Total</p>
          </div>
          <div>
            <p className="text-lg">{leave.used_leaves}</p>
            <p className="text-gray-500 text-xs">Used</p>
          </div>
          <div>
            <p className="text-lg text-green-600">{leave.remaining_leaves}</p>
            <p className="text-gray-500 text-xs">Remaining</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>


      {/* Leave History */}
      <div className="mt-8">
        <h2 className="text-xl font-semibold mb-2">Leave History</h2>
        <div className="w-6 h-1 bg-blue-500 rounded-full mb-4"></div>

        {leaveStatusData?.data?.map((item, index) => (
          <div
            key={item.id || index}
            className={classNames(
              'rounded-xl p-4 mb-4 text-black text-sm leading-6',
              getStatusColor(item.status)
            )}
          >
            <p>
              <strong>Leave Status:</strong> {item.status}
            </p>
            <p>
              <strong>Leave Type:</strong> {item.leave_gov_type}
            </p>
            <p>
              <strong>From:</strong> {formatDate(item.start_date)}
            </p>
            <p>
              <strong>To:</strong> {formatDate(item.end_date)}
            </p>
            <p>
              <strong>Applied on:</strong> {formatDate(item.applied_at)}
            </p>
            <p>
              <strong>Leave Reason:</strong> {item.reason}
            </p>
            {item.status === 'rejected' && item.leaves_status && (
              <p>
                <strong>Reject Reason:</strong> {item.leaves_status}
              </p>
            )}
          </div>
        ))}

        <div className="mb-24"></div>

      </div>
    </div>
  );
};

export default LeaveDetails;
